import { useNavigate, useParams } from 'react-router-dom';
import DailyGridSelector from '../components/DailyGridSelector'
import { GridContainer, GridH1 } from '../components/GridStyles';
import GridLegand from '../components/GridLegand';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
	fetchChannelLineup, selectGridLineupID, selectLineupChannelsStatus, selectChannelSchedule, selectLineupChannels,
	selectDailyGridDay, setDailyGridDay, selectGridDay, selectGridMonth, selectGridYear,
	setGridDay
} from '../mainGridSlice';
import { selectUserId } from '../../UserSettingsPages/SettingsState/userSlice';
import { leadingZeroBuilder } from '../../Global/GobalFunctions';
import GridLoading from '../components/GridLoading';
import { DataState } from '../../../interfaces/enums';
import DailyGridComponent from '../components/DailyGridComponent';
import GridFailed from '../components/GridFailed';
import {
	fetchFavorites, selectFavoritesStatus
} from '../../UserSettingsPages/SettingsState/favoritesRemidersSlice';
import { DataError } from '../../UserSettingsPages/components/SettingsStyles';
import { handleErrorMessage } from '../../Global/ErrorMessage';
import { selectDailyGridWidth } from '../../UserSettingsPages/SettingsState/gridSettingsSlice';
import { handleGA4PageHit } from '../../Global/GA4Functions';

const DailyGrid = () => {
	const dispatch = useAppDispatch();
	const params = useParams();
	const nav = useNavigate()
	let channelIndex = '';
	const day = useAppSelector(selectGridDay);
	const month = useAppSelector(selectGridMonth);
	const year = useAppSelector(selectGridYear)

	const userId = useAppSelector(selectUserId);
	const lineupId = useAppSelector(selectGridLineupID);
	const date = useAppSelector(selectDailyGridDay);
	const channels = useAppSelector(selectLineupChannels);
	const loading = useAppSelector(selectLineupChannelsStatus);
	const channelLineup = useAppSelector(selectChannelSchedule);
	const favStatus = useAppSelector(selectFavoritesStatus)
	const dailyGridWidth = useAppSelector(selectDailyGridWidth)

	if (JSON.stringify(channels) === '{}') {
		nav('/', { replace: true })
	}

	if (params.channelIndex !== undefined) {
		channelIndex = params.channelIndex;
	} else {
		nav('pagenotfound', { replace: true })
	}

	// let channel = channels.channels.find((c) => {
	// 	return c.channelIndex + '' === channelIndex;
	// });

	useEffect(() => {
		document.title = "Daily Grid | TitanTV";
		document.querySelector('meta[name="description"]')?.setAttribute('content', "An optional view of the full 24-hour schedule for the selected channel.");
		document.querySelector('meta[name="robots"]')?.setAttribute('content', "noindex");
		window.scrollTo(0, 0);
		handleGA4PageHit({ page: '/dailygrid', title: 'Daily Grid' });

		date.setHours(0, 0, 0, 0)
		date.setFullYear(parseInt(year), parseInt(month) - 1, parseInt(day))
		dispatch(setDailyGridDay({ date: date, width: dailyGridWidth }));
		const timeStamp = date.getFullYear() + leadingZeroBuilder(date.getMonth() + 1) + leadingZeroBuilder(date.getDate()) + '0000';
		dispatch(fetchChannelLineup({ userId: userId, lineupId: lineupId, timeStamp, duration: '1440', channelIndex: channelIndex }));
		if (favStatus !== DataState.SUCCEEDED) {
			dispatch(fetchFavorites(userId));
		}
		// eslint-disable-next-line
	}, []);

	return (
		<GridContainer>
			{loading === DataState.FAILED ? <GridFailed errorCode={channelLineup.errorCode} errorMessage={channelLineup.errorMessage} /> :
				loading === DataState.LOADING ? <GridLoading /> :
					channelLineup.errorCode !== 0 ?
						<DataError>{handleErrorMessage(channelLineup.errorCode)}</DataError> :
						<>
							<DailyGridSelector />
							<DailyGridComponent channelIndex={channelIndex} />
						</>

			}
			{/* <GridH1>Schedule for {channel?.description}</GridH1> */}
			<GridLegand />
		</GridContainer>
	)
}

export default DailyGrid